const pagingAndSorting = {
  currentPage: 1,
  sortBy: null,
  sortDesc: false,
  itemsPerPage: 10
}

export default ({
  currentPage = 1,
  sortBy = null,
  sortDesc = false,
  itemsPerPage = 10
}) => Object.assign({}, pagingAndSorting, {
  currentPage,
  sortBy,
  sortDesc,
  itemsPerPage
})
